import React from "react";
import Contacts from "@/components/pages/contacts";
import { graphql } from "gatsby";
import SEOEn from "@/components/seo/index.en";
import SEORu from "@/components/seo/index.ru";

const ContactsRu = (props) => {
  const { pageContext } = props;

  return (
    <>
      {pageContext.langKey === "en" && (
        <SEOEn
          title={props.data.layoutContacts.title}
          description={props.data.layoutContacts.ogDescription?.ogDescription}
          ogImage={props.data.layoutContacts.ogImage}
        />
      )}
      {pageContext.langKey === "ru" && (
        <SEORu
          title={props.data.layoutContacts.title}
          description={props.data.layoutContacts.ogDescription?.ogDescription}
          ogImage={props.data.layoutContacts.ogImage}
        />
      )}

      <Contacts {...props} />
    </>
  );
};

export const pageQuery = graphql`
  query($locale: String!) {
    layoutContacts: contentfulLayoutContacts(node_locale: { eq: $locale }) {
      ...ContactsPageFragment
    }
  }
`;

export default ContactsRu;
